import { type ClassValue, clsx } from "clsx"
import { parse } from "date-fns";
import { twMerge } from "tailwind-merge"
import { z } from "zod";
import DOMPurify from 'isomorphic-dompurify'

const { sanitize } = DOMPurify;

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function formatCurrency(amount: number, currency: 'USD' | 'CAD', cents: boolean = true) {
  let formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: currency,
  });

  return cents ? formatter.format(amount / 100) : formatter.format(amount);
}

export const titleCase = (s: string) =>
  s.toLowerCase().replace (/^[-_]*(.)/, (_, c) => c.toUpperCase())       // Initial char (after -/_)
   .replace (/[-_]+(.)/g, (_, c) => ' ' + c.toUpperCase()) // First char after each -/_

export const dateFromStringField = (field: z.ZodDate) => {
  return z.preprocess((arg => arg ? parse(arg as string, 'yyyy-MM-dd', new Date()) : undefined), field)
}

if (typeof window !== 'undefined') {
  DOMPurify.addHook('afterSanitizeAttributes', function (node) {
    // set all elements owning target to target=_blank
    if ('target' in node) {
      node.setAttribute('target', '_blank');
      node.setAttribute('rel', 'noopener');
    }
  });
}

export { sanitize };